import { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import { CoreButton } from "../../core/ui/button/button";
import { CoreText, CoreTextType } from "../../core/ui/text/text";
import { ModalV2 } from "../../core/ui/modal/modal";
import { SessionControls } from "../authorization/session_controls";
import { ExamStore } from "./exam_store";
import "../task/task.css";
import "./exam.css";

export const ExamScreen = observer(() => {
  const [store] = useState(() => new ExamStore());
  const [deleting, setDeleting] = useState<string>();
  useEffect(() => {
    store.list();
  }, [store]);
  return (
    <main className="task-page">
      <SessionControls />
      <header className="task-header">
        <CoreText as="h1" type={CoreTextType.big} text="Тесты и варианты" />
        <CoreButton to="/exam/new" filled>
          Создать подборку
        </CoreButton>
      </header>
      {store.error && (
        <p role="alert" className="error-banner">
          {store.error}
        </p>
      )}
      {store.busy && <p role="status">Загрузка…</p>}
      <section className="panel">
        {!store.models.length && !store.busy && <p>Подборок пока нет.</p>}
        {store.models.map((exam) => (
          <article className="exam-row" key={exam._id}>
            <div>
              <CoreText as="h2" type={CoreTextType.header} text={exam.title} />
              <p className="muted">
                {exam.kind === "variant"
                  ? `Вариант ${exam.year || ""}`
                  : "Текущий тест"}
              </p>
              <p className="muted">
                {Array.isArray(exam.taskIds)
                  ? `Заданий: ${exam.taskIds.length} · ${exam.status === "published" ? "Опубликовано" : "Черновик"}`
                  : "Старый формат подборки"}
              </p>
              <p className="muted">
                {exam.totalScore != null
                  ? `Максимум: ${exam.totalScore} баллов · `
                  : ""}
                {exam.expiresAt
                  ? `До ${new Date(exam.expiresAt).toLocaleString("ru-RU", { timeZone: "Europe/Moscow" })} (Москва)`
                  : "Бессрочный"}
              </p>
            </div>
            <div className="row-actions">
              <CoreButton to={`/exam/${exam._id}/edit`}>Открыть</CoreButton>
              <CoreButton to={`/exam/${exam._id}/results`}>
                Результаты
              </CoreButton>
              <CoreButton
                disabled={store.busy}
                onClick={() => setDeleting(exam._id)}
              >
                Удалить
              </CoreButton>
            </div>
          </article>
        ))}
        <div className="row-actions">
          {(store.page > 0 || store.models.length >= 10) && (
            <>
              <CoreButton
                disabled={store.busy || store.page === 0}
                onClick={() => store.list(store.page - 1)}
              >
                Назад
              </CoreButton>
              <span>Страница {store.page + 1}</span>
              <CoreButton
                disabled={store.busy || store.models.length < 10}
                onClick={() => store.list(store.page + 1)}
              >
                Далее
              </CoreButton>
            </>
          )}
          <CoreButton disabled={store.busy} onClick={() => store.list()}>
            Обновить
          </CoreButton>
        </div>
      </section>
      {deleting && (
        <ModalV2
          isOpen
          titleId="delete-exam-title"
          onClose={() => {
            if (!store.busy) setDeleting(undefined);
          }}
        >
          <CoreText
            as="h2"
            id="delete-exam-title"
            type={CoreTextType.header}
            text="Удалить подборку?"
          />
          <p>Задания останутся в банке.</p>
          {store.error && <p role="alert">{store.error}</p>}
          <div className="row-actions">
            <CoreButton
              disabled={store.busy}
              onClick={() => setDeleting(undefined)}
            >
              Отмена
            </CoreButton>
            <CoreButton
              disabled={store.busy}
              onClick={async () => {
                if (await store.deleteExam(deleting)) setDeleting(undefined);
              }}
            >
              Удалить подборку
            </CoreButton>
          </div>
        </ModalV2>
      )}
    </main>
  );
});
